import {Button, Form} from 'react-bootstrap';
import '../styles/login.css'

function ForgotUsernameForm({
    forgotEmailVal,
    setForgotEmailVal,
    handleSubmit,
}) {
    
    return (
        <>
            <div className='login-section'>
                <Form>
                    <Form.Group className='mb-3 lookup-username-form' controlId='formBasicNameSignup'>
                        <Form.Label>Lookup Username</Form.Label>
                        <Form.Control value={forgotEmailVal} onChange={(e) => setForgotEmailVal(e.target.value)} type='code' placeholder='email' />
                        <Form.Text className='text-muted'>
                        </Form.Text>
                    </Form.Group>
                </Form>
                <Button onClick={handleSubmit} variant='primary'>Get Username</Button>
            </div>
        </>       
    );

}

export default ForgotUsernameForm;